import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button, Spinner } from "reactstrap";

// utils
import { removeAllCookies, setSessionCookie } from "utils/cookies.js";
import { LogoOperadora } from "constants/Logotipo";
import { showMessage } from "utils/message.js";

// api
import usuario_api from "api/usuario_api.js";

export default function Login({ history }) {

    const { register, handleSubmit, errors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    useEffect(() => {
        removeAllCookies();
    }, []);

    const onSubmit = (data) => {
        let json_submit = {
            login: data.login,
            senha: data.senha
        }

        setshowLoading(true);
        usuario_api.authenticate(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else if (result.data == null) {
                showMessage("Aviso", "Usuário/Senha não encontrado", 'warning', null);
            }
            else {                
                setSessionCookie(result.data);
                history.push("/admin/inicio");
            }
        });
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }

            <Card style={{ marginTop: "10vh" }}>
                <CardBody>
                    <Container>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="mt-4 pl-4">
                                <Col lg="6" md="12" className="text-center">
                                    <h5>Bem Vindo ao DRE TIM!</h5>
                                    <label className="text-center">Sistema de Demonstração do Resultado do Exercício</label>
                                    <div className="mb-4">
                                        <img src={LogoOperadora()} className="img-logo" height="100px" />
                                    </div>
                                </Col>
                                {/* <Col lg="6" md="12" className="mb-4">
                                    <h5>Este Sistema está temporáriamente indisponível!</h5>
                                    <h6>Para mais informações entre em contato:</h6>
                                    <h6>
                                        <i class="fas fa-phone"></i> Telefone: (12) 3042-1125 / (12) 3600-2393
                                    </h6>
                                </Col> */}
                                <Col lg="6" md="12" className="mb-4">
                                    <Row>
                                        <Col md="12">
                                            < Row>
                                                <Col md="12" lg="12">
                                                    <h5 className="text-center">Dados de Acesso</h5>
                                                    <FormGroup>
                                                        <label>Usuário</label>
                                                        <Input type="login" name="login" maxLength="200" innerRef={register({ required: true })} />
                                                        {errors.login && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <label>Senha</label>
                                                        <Input type="password" name="senha" maxLength="100" innerRef={register({ required: true })} />
                                                        {errors.senha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                    <a style={{ cursor: "pointer" }} onClick={() => { history.push("/auth/esqueceusenha"); }}>Esqueci a senha</a>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <div className="text-right">
                                        <Button color="default" type="submit">ENTRAR </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </CardBody>
            </Card>
        </>
    );
}